module.exports = {
	"shared.crew.original-music-composer": "Musicien/compositeur",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publiciste",
	"share-overlay.share": "Partager cette vidéo",
	"shared.crew.associate-producer": "Assistant réalisateur",
	"shared.crew.assistant-editor": "Administrateur de production",
	"overlay.buy-from": "Acheter pour {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Assistant photographie",
	"shared.crew.sound-editor": "Chef-opérateur du son",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Coiffeur",
	"shared.crew.makeup-effects": "Effets maquillage",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Assistant de production",
	"shared.crew.executive-producer": "Producteur exécutif",
	"shared.crew.costumer": "Habilleur",
	"info-overlay.cast": "acteurs",
	"shared.crew.stunt-coordinator": "Cascadeur",
	"shared.crew.academic-advisor": "Conseiller pédagogique",
	"shared.crew.swing-gang": "Directeur technique",
	"shared.crew.best-boy": "Régisseur",
	"actions.purchased": "Vous être le propriétaire de cette vidéo",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Chef décorateur",
	"shared.crew.adaptation": "Adaptation",
	"shared.crew.school-administrator": "Administrateur scolaire",
	"shared.crew.cable-person": "Directeur technique",
	"shared.crew.digital-effects": "Effets digitaux",
	"actions.rent": "Louer {price}",
	"info-overlay.created-by": "Par {author}",
	"social-share.twitter": "Regarder \"{title}\" sur {siteUrl}",
	"shared.crew.production-designer": "Administrateur de production",
	"info-overlay.crew": "équipe",
	"shared.crew.producer": "Producteur",
	"shared.crew.2nd-unit-dir-of-photography": "2e directeur de photographie",
	"shared.crew.special-effects": "Effets spéciaux",
	"actions.rented": "Loué jusqu'au {date}",
	"shared.crew.boom-operator": "Perchman",
	"shared.crew.story": "Histoire",
	"shared.crew.script-supervisor": "Scripte",
	"shared.crew.director": "Réalisateur",
	"shared.crew.choreographer": "Chorégraphe",
	"shared.crew.production-manager": "Chargé de production",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Chef staffeur",
	"shared.crew.location-manager": "Régisseur général",
	"shared.crew.costume-designer": "Costumier créateur",
	"fullscreen.exit": "Fermer plein écran",
	"shared.crew.technical-advisor": "Technicien de maintenance",
	"shared.crew.editor": "Éditeur ",
	"shared.crew.additional-grip": "Machiniste",
	"actions.buy": "Acheter {price}",
	"shared.crew.assistant-camera": "1er assistant opérateur",
	"shared.crew.writer": "Écrivain",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Assistant réalisateur",
	"fullscreen.enter": "Plein écran",
	"shared.crew.animal-trainer": "Dompteur animaux",
	"shared.crew.assistant-art-director": "Assistant directeur artistique",
	"shared.crew.key-grip": "Percheur",
	"social-button.copy": "Copier",
	"shared.crew.makeup-artist": "Maquilleur",
	"overlay.source-error": "La vidéo ne peut pas être lue",
	"social-button.link": "Lien",
	"actions.buy-from": "Acheter pour {price}",
	"shared.crew.art-director": "Directeur artistique",
	"shared.crew.production-coordinator": "Coordinateur de production",
	"shared.crew.co-director": "Co-réalisateur",
	"shared.crew.co-producer": "Co-producteur",
	"shared.crew.video-operator": "Projectionniste",
	"shared.crew.camera-operator": "Cadreur",
	"shared.crew.co-writer": "Co-scénariste",
	"shared.crew.set-designer": "Ensemblier",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Directeur de l'exploitation",
	"shared.crew.cinematographer-dp": "Directeur de la photographie",
	"shared.crew.grip": "Perche",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Ingénieur du son",
	"quality.label": "Qualité",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Chef-électricien",
	"shared.crew.assistant-director": "Assistant de production",
	"actions.subscribe": "Souscription {price}/mois",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animateur",
	"shared.crew.dolly-grip": "Perchiste",
	"shared.crew.manager": "Gérant",
	"shared.crew.2nd-assistant-director": "2e assistant réalisateur",
	"shared.crew.author-of-adapted-material": "Auteur ou matériel"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_fr.json
// module id = 1439
// module chunks = 0 1 2 3